import { AuthConfig } from "angular-oauth2-oidc";
import { urls } from "./url.utils";

export const authConfig: AuthConfig = {
  issuer: 'https://accounts.google.com',
  redirectUri: urls.REDIRECT_URI,
  clientId: urls.GOOGLE_CLIENT_ID,
  responseType: 'id_token token',
  scope: 'openid profile email',
  strictDiscoveryDocumentValidation: false,
  loginUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
  tokenEndpoint: 'https://oauth2.googleapis.com/token',
  userinfoEndpoint: 'https://openidconnect.googleapis.com/v1/userinfo',
  showDebugInformation: true
};